var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9694 11.6147H21.6429C24.7862 11.6147 27.3346 14.1075 27.3346 17.1821V23.766C27.3346 26.8405 24.7862 29.3333 21.6429 29.3333H10.3583C7.21644 29.3333 4.66797 26.8405 4.66797 23.766V17.1821C4.66797 14.6535 6.40218 12.5424 8.76233 11.8639L8.61465 11.8811V9.84951C8.64175 5.88834 11.9354 2.66666 15.9729 2.66666C19.1297 2.66666 21.9193 4.6161 22.949 7.50382C23.0574 7.79537 23.0303 8.11343 22.8948 8.39173C22.7593 8.67004 22.5168 8.88208 22.2174 8.97617C21.6077 9.18688 20.9303 8.87015 20.6999 8.26053C20.009 6.29784 18.1135 4.98584 15.9999 4.98584C13.2347 4.98584 11.0005 7.16058 10.9856 9.823V11.6121L10.9694 11.6147ZM15.9945 23.1047C16.6584 23.1047 17.1868 22.5878 17.1868 21.9384V18.9964C17.1868 18.3603 16.6584 17.8434 15.9945 17.8434C15.3442 17.8434 14.8158 18.3603 14.8158 18.9964V21.9384C14.8158 22.5878 15.3442 23.1047 15.9945 23.1047Z",
    fill: "#12B76A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/Unlock.85cb5f7eeb1454c60b9e84df7a052e70.svg";
export { ForwardRef as ReactComponent };